<template>
  <div :class="[$style.wrapper, finish && $style.finish]">
    <v-help button="НАЧАТЬ" ref="startBox" @click="() => openWindow('browser')">
      Перед тобой «Чек-лист безопасности в Интернете». Помоги Скобцу выполнить все действия из списка, чтобы вернуть приватность его учетным записям.
    </v-help>
    <v-help button="OK" ref="box1">
      Введи адрес почты Скобца, чтобы узнать, знает ли кто-то еще его пароли от учетных записей.
    </v-help>
    <v-help button="OK" ref="box2">
      Помоги поменять пароль Скобца на разных сайтах. <br><br> Помни: <br>
      - пароль должен быть сложным;<br>
      - создавай разные пароли для разных сайтов;<br>
      - используй двухфакторную авторизацию.<br><br>
      Двухфакторная авторизация — дополнительный уровень безопасности, который гарантирует, что доступ к вашей учетной записи можете получить только вы. Например: после ввода пароля от личного кабинета, сайт попросит сообщить специальный код, который будет отправлен вам на почту или телефон.<br>
      Никому НЕ сообщайте этот код!
    </v-help>
    <v-help button="OK" ref="box3">
      Когда сайтов много, сложно запомнить все пароли. Помоги Скобцу сохранить все пароли в менеджере паролей.
    </v-help>
    <v-help button="OK" ref="box4">
      Чтобы пароли оставались надежными, их лучше менять каждые 3–6 месяцев. Помоги Скобцу поставить напоминание в календаре о смене паролей.
    </v-help>
    <v-help button="Далее" ref="successBox" @click="success">
      Тебе удалось помочь Скобцу сменить пароли от учетных записей и сохранить приватность!
    </v-help>
    <v-help button="ОК" ref="errorBox">
      {{ errorText }}
    </v-help>
    <v-help button="ОК" ref="passwordErrorBox">
      Сначала нужно проверить и поменять пароли!
    </v-help>

    <transition name="bounce">
      <h2 v-if="finish">Молодец!</h2>
    </transition>

    <div :class="$style.apps">
      <div @click="() => openWindow('browser')" :class="$style.app"><img src="./assets/browser.svg" alt="browser"><div :class="$style.appTitle"><span>K</span>Browser</div></div>
      <div @click="() => openWindow('passwords')" :class="$style.app"><img src="./assets/settings.svg" alt="settings"><div :class="$style.appTitle"><span>K</span>Password</div></div>
      <div @click="() => openWindow('calendar')" :class="$style.app"><img src="./assets/calendar.svg" alt="calendar"><div :class="$style.appTitle"><span>K</span>Calendar</div></div>
    </div>

    <v-progress :data="data" ref="progress" />
    <browser :data="data" ref="browser" @success="handleNext" @box="handleBox" />
    <passwords :data="data" ref="passwords" @success="handleNext" @box="handleBox" />
    <calendar :data="data" ref="calendar" @success="handleNext" @box="handleBox" />
  </div>
</template>
<script>
import VProgress from './components/progress/progress'
import browser from './components/browser/browser'
import passwords from './components/passwords/passwords'
import calendar from './components/calendar/calendar'

import data from './data'

export default {
  name: 'trainer3',
  components: {
    VProgress, browser, passwords, calendar,
  },
  data: () => ({
    data,
    stage: 0,
    finish: false,
    errorText: '',
  }),
  methods: {
    openWindow(ref) {
      this.$refs.browser.close()
      this.$refs.passwords.close()
      this.$refs.calendar.close()

      if (ref === 'passwords' && !this.data.tasks[2].ready) {
        this.errorText = 'Сначала нужно проверить и поменять пароли!'
        this.$refs.errorBox.open()
        return
      }

      if (ref === 'browser' && this.data.tasks[1].ready) {
        this.errorText = 'Мы уже поменяли пароли!'
        this.$refs.errorBox.open()
        return
      }

      this.$refs[ref].open()
    },
    runNextBox() {
      const [task1, task2,,,,,,, task8, task9] = this.data.tasks
      if (!task1.ready) {
        this.handleBox('box1')
        return
      }
      if (!task2.ready) {
        this.handleBox('box2')
        return
      }
      if (!task8.ready) {
        this.handleBox('box3')
        return
      }
      if (!task9.ready) {
        this.handleBox('box4')
      }
    },
    handleNext() {
      this.runNextBox()
      this.check()
    },
    handleBox(ref) {
      const exlc = ['progress', 'browser', 'passwords', 'calendar']
      if (this.$refs[ref] && this.$refs[ref].open) {
        Object.keys(this.$refs).forEach(k => !exlc.includes(k) && this.$refs[k].close())
        this.$refs[ref].open()
      }
    },
    check() {
      const { tasks } = this.data

      if (tasks.filter(i => i.ready).length === tasks.length) {
        this.finish = true
        this.$refs.successBox.open()
      }
    },
    success() {
      this.$emit('success')
    },
  },
  mounted() {
    setTimeout(() => {
      this.$store.commit('SET_HEX_COLOR', 'purpleBlue')
      this.$store.commit('SET_HEX_ROTATION')
      this.$refs.startBox.open()
      // this.handleNext()
    }, 500)
  },
}
</script>
<style lang="scss" module src="./trainer3.scss"></style>
